import { MoedasScreen } from "@/screens/financeiro/configuracoes/moedas";

export function FinanceiroMoedasPage() {
  return <MoedasScreen />;
}
